import type { PasswordScorer } from './passwordValidation';

// zxcvbn-ts and its dictionaries are several MB, so they load on demand as a separate chunk
// instead of shipping with the sign-up page. The configuration must mirror user-service
// PasswordValidatorService so both sides score a password the same way.
let loadedScorer: PasswordScorer | null = null;
let loading: Promise<PasswordScorer> | null = null;

export function getLoadedPasswordScorer(): PasswordScorer | null {
    return loadedScorer;
}

export function loadPasswordScorer(): Promise<PasswordScorer> {
    if (loadedScorer) {
        return Promise.resolve(loadedScorer);
    }
    if (!loading) {
        loading = Promise.all([
            import('@zxcvbn-ts/core'),
            import('@zxcvbn-ts/language-common'),
            import('@zxcvbn-ts/language-en'),
        ])
            .then(([core, common, en]) => {
                const zxcvbn = new core.ZxcvbnFactory({
                    dictionary: { ...common.dictionary, ...en.dictionary },
                    graphs: common.adjacencyGraphs,
                    translations: en.translations,
                    useLevenshteinDistance: true,
                });
                loadedScorer = (password: string) => zxcvbn.check(password).score;
                return loadedScorer;
            })
            .catch((error: unknown) => {
                // Allow a later focus to retry after a transient chunk-load failure.
                loading = null;
                throw error;
            });
    }
    return loading;
}
